<template>
  <v-app>
    <v-app-bar app
               dense
               flat
               color="primary"
               dark
    >
      <v-toolbar-title>{{ title }}</v-toolbar-title>


      <v-spacer></v-spacer>




      <v-btn icon @click="link">
        <v-icon>{{ icon }}</v-icon>
      </v-btn>

      <v-btn icon @click="logout">
        <v-icon>mdi-logout</v-icon>
      </v-btn>

    </v-app-bar>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
// @ is an alias to /src
import {setDocumentDirectionPerLocale, setDocumentLang} from "../util/i18n/document";

export default {
  name: 'Home',
  methods: {
    logout() {
      localStorage.removeItem('token')
      this.$router.push('/auth/' + this.$route.params.lang+ "/login")
    },
    link() {
      if (this.$route.name === 'Profile') {
        this.$router.push('/' + this.$route.params.lang)

        this.$router.push({name: 'Submit'})
      } else {
        this.$router.push('/' + this.$route.params.lang+ "/profile")
        this.$router.push({name: 'Profile'})
      }
    }
  },
  data: () => ({
    title: document.title
  }),
  computed: {

    icon() {
      return this.$route.name === 'Profile' ? 'mdi-plus' : 'mdi-account'
    },

  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.title = to.meta.title || 'Madrese International Film Festival';
      }
    },
  },
  mounted() {
    this.$i18n.locale = this.$route.params.lang
    if(this.$i18n.locale === 'fa' || this.$i18n.locale === 'ar'){
      this.$store.dispatch('setFont','font-family:IRANSans,serif')
    }else{
      this.$store.dispatch('setFont','font-family:Time New Roman')
    }
    this.$watch("$i18n.locale", (newLocale , oldLocale) => {
          if( newLocale === oldLocale){
            return
          }

          setDocumentLang(newLocale)
          setDocumentDirectionPerLocale(newLocale)
        },
        {immediate: true}
    )

  }
}
</script>
